export const WHATSAPP_NUMBER = "5521994876179";

export const waLink = (message = "Olá! Gostaria de falar com as advogadas.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
